import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";


const Chip = ({ label, onClick, style, loading = false }) => {
    return (
    <span
        className="sapa-chip"
        style={
            {
                ...style
            }
        }
        onClick={onClick}
    >
        {loading? <Spin size="small" style={{color: 'blue'}} indicator={<LoadingOutlined />} /> : label}
    </span>);
}

export default Chip;
